import { Radio, RadioProps } from 'antd'
import { createElement, useEffect, useState } from 'react'

import { ComponentController } from './component_controller'

const UpdateableRadioGroup = (props: RadioProps) => {
  const [value, setValue] = useState(props.value)
  useEffect(() => {
    setValue(props.value)
  }, [props.value])
  const onChange = (e) => {
    setValue(e.target.value)
  }
  return createElement(Radio.Group, { ...props, value, onChange })
}

export class RadioController extends ComponentController<RadioProps> {
  get component() {
    return UpdateableRadioGroup
  }
}
